const React = require("react");
const createReactClass = require("create-react-class");
const {augmentHOCWrapper} = require("../util/HOCUtil");

// Copies a lot of the InitRenderSwitch implementation. We do this because our
// HOC util really wants HOCs to return the original component in render to
// do ref forwarding correctly, so we can't return InitRenderSwitch.

module.exports = augmentHOCWrapper(function(Component) {
	return createReactClass({
		displayName: "RenderSwitch:" + Component.displayName,

		getInitialState: function() {
			return {useFirstRenderChildren: !global.hasFirstRenderOccurred};
		},

		componentDidMount: function() {
			if (this.state.useFirstRenderChildren) {
				// eslint-disable-next-line react/no-did-mount-set-state
				this.setState({useFirstRenderChildren: false});
			}
		},

		render: function() {
			return (
				<Component
					isFirstRender={this.state.useFirstRenderChildren}
					{...this.props}
				/>
			);
		},
	});
});
